import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const CASAVI_CONTACT_BLACKLIST_CREATE_RESOURCE = "casavi-contact-blacklist" as const;
export const CASAVI_CONTACT_BLACKLIST_CREATE_API_PATH = `/v1/${CASAVI_CONTACT_BLACKLIST_CREATE_RESOURCE}` as const;

export type CasaviContactBlacklistCreateBody =
  paths[typeof CASAVI_CONTACT_BLACKLIST_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type CasaviContactBlacklistCreateResponse =
  paths[typeof CASAVI_CONTACT_BLACKLIST_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useCasaviContactBlacklistCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CasaviContactBlacklistCreateResponse, Error, CasaviContactBlacklistCreateBody>({
    mutationFn: async (casaviContactBlacklist: CasaviContactBlacklistCreateBody) => {
      const response = await alphartisApiAxios.post<CasaviContactBlacklistCreateResponse>(
        CASAVI_CONTACT_BLACKLIST_CREATE_API_PATH,
        casaviContactBlacklist,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [CASAVI_CONTACT_BLACKLIST_CREATE_RESOURCE],
      });
    },
  });
};
